import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert } from "@mui/material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import CollectionForm from "./CollectionComponents/CollectionForm";

import { useAddCollectionMutation } from "store/services/collectionApi";

const CollectionCreateScreen = () => {

  const navigate = useNavigate();
  
  const [vendorPaymentTerms, setVendorPaymentTerms] = useState(null);

  const breadcrumbs = [
    { title: "Collections", path: "/app/crm/collection/list" },
    { title: "New Collection" },
  ];

  // RTK query hook for adding a collection
  const [addCollection, { isLoading }] = useAddCollectionMutation();

  const handleCreateShipmentFulfillment = async (data) => {
    try {
      const { _id } = await addCollection(data).unwrap();
      toast.success("Collection successfully created!");
      navigate(`/app/crm/collection/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create collection!"
      );
    }
  };

  // Callback to receive selected vendor's paymentTerms from CollectionForm
  const handleVendorChange = (vendor) => {
    setVendorPaymentTerms(vendor?.paymentTerms || null);
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        {vendorPaymentTerms !== "Contract" && (
          <Alert severity="info" sx={{ mb: 2 }}>
            To collect shipments, you must add a price with <strong>Charge</strong> type first.
          </Alert>
        )}
        <CollectionForm
          isBusy={isLoading}
          onSubmit={handleCreateShipmentFulfillment}
          onVendorChange={handleVendorChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CollectionCreateScreen;